import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Compass, BedDouble, UtensilsCrossed } from "lucide-react";
import api from "../lib/api";
import { vibrantTheme } from "./common";

/* "Stay, Eat & Explore" near an airport — curated destination data matched by IATA. */
export const AirportNearby = ({ iata }) => {
  const [d, setD] = useState(null);

  useEffect(() => {
    if (!iata) return;
    api.get(`/destinations/by-airport/${iata}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [iata]);

  if (!d) return null;
  const theme = vibrantTheme(`${d.id}-nearby`);

  return (
    <section className="border border-zinc-300 bg-white p-5 sm:p-6 border-l-4" style={{ borderLeftColor: theme.bg }}
      data-testid="airport-nearby-block">
      <div className="flex items-center gap-2 mb-1">
        <Compass className="w-5 h-5" style={{ color: theme.bg }} />
        <h2 className="font-heading font-900 text-xl">Stay, Eat &amp; Explore: {d.name}</h2>
      </div>
      {d.tagline && <p className="text-sm text-zinc-700 mb-3">{d.tagline}</p>}
      {d.attractions?.length > 0 && (
        <ul className="space-y-1.5 mb-3">
          {d.attractions.map((a) => (
            <li key={a.name} className="text-sm text-zinc-700 flex gap-2">
              <span style={{ color: theme.bg }}>{"\u2022"}</span>
              <span><strong>{a.name}</strong>{a.blurb ? ` — ${a.blurb}` : ""}</span>
            </li>
          ))}
        </ul>
      )}
      {d.getting_around && <p className="text-sm text-zinc-700 mb-3"><strong>Getting around:</strong> {d.getting_around}</p>}
      <div className="flex flex-wrap gap-2">
        <Link to={`/destinations/${d.id}`} data-testid="nearby-destination-link"
          className="px-3 py-1.5 text-sm font-700 text-white" style={{ backgroundColor: theme.bg }}>
          Full {d.name} guide {"\u2192"}
        </Link>
        <Link to="/stays" className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-700 border" style={{ borderColor: theme.bg, color: theme.bg }} data-testid="nearby-stay-link">
          <BedDouble className="w-4 h-4" /> Places to stay
        </Link>
        <Link to="/guides/stay" className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-700 border" style={{ borderColor: theme.bg, color: theme.bg }} data-testid="nearby-dining-link">
          <UtensilsCrossed className="w-4 h-4" /> Dining guide
        </Link>
      </div>
    </section>
  );
};
